import { createSlice } from '@reduxjs/toolkit';
import { getCustomerServices } from './thunks';
import { logOut } from '../authentication/authenticationSlice';

const initialState = {
  servicesByCustomer: {},
  loading: 'idle',
  error: null
};

const customerServicesSlice = createSlice({
  name: 'customerServices',
  initialState,
  reducers: {
    clearCustomerServicesError: (state) => {
      state.error = null;
      state.loading = 'idle';
    }
  },
  extraReducers: {
    [getCustomerServices.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getCustomerServices.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      if (action.payload && action.meta && action.meta.arg) {
        const customerId = action.meta.arg.param || action.meta.arg;
        state.servicesByCustomer[customerId] = Array.isArray(action.payload)
          ? action.payload
          : (action.payload.value || []);
      }
    },
    [getCustomerServices.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error ? action.error.message : 'Error';
    },
    [logOut]: () => initialState
  }
});

export const { clearCustomerServicesError } = customerServicesSlice.actions;
export default customerServicesSlice.reducer;
